import React, {useEffect,useState} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api';
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/default-user.jpg';
let HISTORY = [];
let ATTACHMENTS = [];
function ProjectTaskDetail(props){
    const [taskDetails, setTaskDetails] = useState(false);
    const [taskHistory, setTaskHistory] = useState(HISTORY);
    const [taskAttachments, setTaskAttachments] = useState(ATTACHMENTS);
    useEffect(() => {
        getTaskDetails();
    },[]);

    function getTaskDetails(){
        var formData=new FormData();
        formData.append("task_id",props.match.params.id);
        
        post(Constent.GETTASKDETAILS,formData).then(response =>{
            if(response.status===1){
                setTaskDetails(response.data.taskdetail);
                setTaskHistory(response.data.history);
                setTaskAttachments(response.data.attachments);
            }else{
                Alert.error({title: response.message});
            }
        })
    }
    return (
	<>
        <div className="header-area project-overview-page" style={{'borderRadius': 0}}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-3 col-3">
                        <Link className="menu-back-page home-clicked" to={'/'}>
                            <i className="fa fa-home" />
                        </Link>
                    </div>
                    <div className="col-sm-6 col-6 text-center">
                        <div className="page-name">Task</div>
                    </div>
                    <div className="col-sm-3 col-3 text-right">
                       <HeaderRight />
                    </div>
                </div>
            </div>
        </div>
        <div className="mg-top-30 sub-header"></div>

	   <div className='project-taskDetails transaction-area mg-bottom-40'>
            <div style={{marginTop:20}}>
                { (!taskDetails) ? <p className="text-center">Loading....</p> : '' }
                    <div className='single-goal'>
                        <h4>{taskDetails.subject}</h4>
                        <p style={{margiBottom: 5}}><span className="color-gray">Assign To</span>
                           <div className="row">
                                {taskDetails.task_assignees && (taskDetails.task_assignees).map((assignee, key) => (
                                    <div className="col-md-1" style={{textAlign: 'center'}}>
                                        <div>
                                            <img src={assignee.assignee_profile_image} alt="file" style={{width:40,height:40, borderRadius: '40px' }}/>
                                        </div>
                                        <div style={{fontSize: '10px'}}>
                                            {assignee.assignee_name} {assignee.assignee_last_name}
                                        </div>
                                    </div>
                                ) )}    
                            </div>
                        </p>
                        <p style={{margiBottom: 5}}><span className="color-gray">Assign By</span> : {taskDetails.assign_by}</p>
                        <div className="primary-text">
                            <span className="color-gray"><i className="fa fa-calendar" aria-hidden="true"></i> Due Date : </span>
                            {(taskDetails.due_date !== '') ? 
                            moment(taskDetails.due_date, "DD-MM-YYYY").format("MMM DD, YYYY")
                             : ''}
                        </div>
                        <div className="primary-text">
                            <span className="color-gray"><i className="fa fa-calendar" aria-hidden="true"></i> Start Date : </span>
                            {(taskDetails.start_date !== '') ? 
                            moment(taskDetails.start_date, "DD-MM-YYYY").format("MMM DD, YYYY")
                             : ''}
                        </div>  
                    </div>

                    <div className='single-goal'>
                        <p><b className="text-overflow">Description :</b></p>
                        <div className="color-gray" dangerouslySetInnerHTML={{__html: (taskDetails.description)}}></div>
                    </div>

                    <div className='single-goal'>
                        <div className="row">
                        {(taskAttachments).map((item,key) => (
                            <div className="col-4 text-center">
                                <img src={item.fileUrl} alt="file" style={{width:50,height:50}}/>
                                <br></br> <a href={item.aHref}>{item.filename}</a>
                            </div>
                        ) )}    
                        </div>
                    </div>

                    <div className='single-goal'>
                        {taskHistory.map((item,key) => (
                        <div className="history" key={key}>
                            <table>
                            <tbody>
                                <tr>
                                    <td><img className="user-img" src={dummyImage} alt="img" /></td>
                                    <td>
                                        <b>{(item.name !== '') ? item.name : '-'}</b>  
                                        <div className="color-gray">
                                       { moment(item.created_at, "YYYY-mm-dd hh:mm:ss").format("MMM DD, YYYY") } 
                                        &nbsp;at { moment(item.created_at, "YYYY-mm-dd hh:mm:ss").format("hh:mm a") }
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <div className="color-gray">{item.comment}</div>
                                    </td>
                                </tr>

                                {(item.attachments).map((item,key) => (
                                <tr key={key}>
                                    <td></td>
                                    <td>
                                        <div className="color-gray">
                                            <img src={item.fileUrl} alt="file" style={{width:20,height:20}}/>
                                            &nbsp; <a href={item.aHref}>{item.filename}</a>
                                        </div>
                                    </td>
                                </tr>
                                ) )}    
                            </tbody>
                            </table>
                            
                            
                        </div>
                        ) )}
                       
                    </div>
                </div>
            </div>

            {/* Footer start */}
            <div className="footer-area">
                <div className="container">
                    <div className="footer-bottom text-center">
                        <div className="row center">
                           <div className="col-8 offset-2 center">
                                
                            </div>
                            <div className="col-2">
                                <Link className="home-clicked" to={'/project-details/'+taskDetails.project_id}>
                                    <i className="fa fa-reply" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}
	</>
	);
    
}

export default (ProjectTaskDetail)